module.exports = __webpack_public_path__ + "static/media/lack-of-bleeding-OFF.f4de160e.png";